import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChange } from '@angular/core';

// import { d4dbService  } from '../../services/d4db.service';

import * as d3 from 'd3';
import * as d3Tip from 'd3-tip';
(d3 as any).tip = d3Tip;
// import * as dbox from '@dboxjs/core';
declare const dbox: any;
import * as _ from 'lodash';

@Component({
  selector: 'dbox-map',
  templateUrl: './dboxMap.component.html',
  styleUrls: ['./dboxMap.component.scss']
})
export class DboxMapComponent implements OnInit, OnChanges {

  @Input() colors;
  @Input() topic;
  @Input() selectedOne;
  @Input() selectedTwo;
  @Input() hover;
  @Input() unhover;
  @Output() onClick = new EventEmitter();
  @Output() onHover = new EventEmitter();
  @Output() onHoverOut = new EventEmitter();

  chart

  /** ngOnInit: Init component, gets municipality data and stores it on chartData,
   * gets data from escuelas_localidad.csv and stores it in mun_localities
   * then draws Localities Scatter
   * @since v2
  */
  ngOnInit() {
    this.draw();
  }

  ngOnChanges(changes: {[propKey: string]: SimpleChange}) {

    for (const propName of Object.keys(changes)) {
      const changedProp = changes[propName];
      const to = JSON.parse(JSON.stringify(changedProp.currentValue));
      if (changedProp.isFirstChange()) {
        // console.log(`Initial value of ${propName} set to ${to}`);
        // this.draw()
      } else {
        const from = JSON.stringify(changedProp.previousValue);
        // console.log(`${propName} changed from ${from} to ${to}`);
        if (propName === 'colors') {
          this.draw()
        }
        if (propName === 'selectedOne' && to !== null && to.by !== 'map') {
          this.select(to);
        }
        if (propName === 'selectedTwo' && to !== null && to.by !== 'map') {
          this.select(to);
        }
        if (propName === 'hover' && to !== null && to.by !== 'map') {
          this.select(to);
        }
        if (propName === 'unhover' && to !== null && to.by !== 'map') {
          this.unselect(to);
        }
      }
    }
  }

  draw() {
    const vm = this;
    const width = $('#map').width(); // Getting scatter container size

    const config = {
      'size': {
        'width': width,
        'height': 480,
        'margin': {top: 0, right: 0, bottom: 0, left: 0},
        'translateX': width * 0.24,
        'translateY': 350,
        'scale': 0.9 * d3.min([width, 646]) / 646
      },
      'xAxis': {
        'enabled' : false
      },
      'yAxis': {
        'enabled' : false
      },
      'map': {
        'quantiles': {
          'buckets': 5,
          'colors': vm.colors.default,
          'colorsOnHover': vm.colors.onHover,
          'ignoreZeros' : false
        },
        'topojson': {
          'url': 'assets/js/states.json',
          'objects': 'states',
          'translate': [2580, 700],
          'scale': 1300,
          'parser': function(d) {
            d.id = +d.properties.state_code;
            return d.id;
          },
          'id': function(d) {
            return 'states-' + d.id;
          }

        }
      },
      'data': {
        'onclick': function(d, i){

          const map = vm.chart.layers[0];

          d3.selectAll('.stip').remove();

          d3.select('#states-' + d.CVE_ENT).attr('fill', function() {
            if (map._config.map.quantiles.colorsOnHover) { // OnHover colors
              return map._getQuantileColor(d[map._config.color], 'onHover');
            }
          })

          vm.onClick.emit({d, i});

          //Waiting for chart to redraw and place tooltips
          setTimeout(function(){
            d3.select('#bars svg').selectAll('.bar').each(function(d,i){
              //Looping through all bar and selecting the ones with color to show tooltip
              var color = d3.select(this).attr('fill');
              if(d3.select(this).attr('fill') === "#e2e2ed" || d3.select(this).attr('fill') === "#c8c8d4" || d3.select(this).attr('fill') === '#aeaebb' || d3.select(this).attr('fill') === '#9494a2' || d3.select(this).attr('fill') === '#7a7a89'){
                d3.selectAll('.state-tip-'+d['CVE_ENT']).remove()
              }
              else if(i !== 32){ //32 is for National, its tootip is defined on Map component
                var stateTip = d3Tip().attr('class', 'stip state-tip-' + d['CVE_ENT']);
                
                stateTip.html(function(d){
                  return d;
                });
                
                d3.select('#bars svg').call(stateTip); 
                var stateBar = d3.select('#bars #bars-' + d['CVE_ENT']);
                var dat = [];
                dat.push(d);
                    
                var stateSelection = vm.selectedTopic(dat);
                
                stateBar.each(function(d){
                  stateTip.show(stateSelection, stateBar.node());
                });

                d3.select('.state-tip-' + d['CVE_ENT']).style('color', d3.select(this).attr('fill'));
              }
                
            });
          }, 300)

        },
        'onmouseover': function(d, i){
          vm.onHover.emit({d, i});
        },
        'onmouseout': function(d, i){
          const map = vm.chart.layers[0];

          if (vm.selectedOne !== null && vm.selectedOne.d.CVE_ENT === d.CVE_ENT) {
            d3.select('#states-' + d.CVE_ENT).attr('fill', function() {
              if (map._config.map.quantiles.colorsOnHover) { // OnHover colors
                return map._getQuantileColor(d[map._config.color], 'onHover');
              }
            })
          }

          if (vm.selectedTwo !== null && vm.selectedTwo.d.CVE_ENT === d.CVE_ENT) {
            d3.select('#states-' + d.CVE_ENT).attr('fill', function() {
              if (map._config.map.quantiles.colorsOnHover) { // OnHover colors
                return map._getQuantileColor(d[map._config.color], 'onHover');
              }
            })
          }

          vm.onHoverOut.emit({d, i});
        },
      },
      'events': {
        'load': function(chart){
          const map = vm.chart.layers[0];

          
          //THIS SECTION APPLIES TOOLTIPS FOR dboxBars.component BECAUSE THE MAP IS THE LAST ELEMENT TO DRAW IN THE BODY

          //Define National tooltips
          var nationalTip = d3Tip().attr('class', 'national-tip');

          nationalTip.html(function(d){
            return d;
          });

          d3.select('#bars svg').call(nationalTip);
          
          var nationalBar = d3.select('#bars').select('#bars-33');

          var nationalData = _.filter(nationalBar.data(), function(d){
            return d.NOM_ENT === "Nacional";
          });

          var natSelection = vm.selectedTopic(nationalData);

          nationalBar.each(function(d){
            nationalTip.show(natSelection, nationalBar.node());
          });
          //National tooltip for Scatter
          var scatterTip = d3Tip().attr('class', 'scatter-tip');

          var national = d3.select('#scatter').select('.scatter-33');
          
          var scatterx = _.filter(national.data(), function(d){
            return d.x;
          });
          

          scatterTip.html(function(d){

            var format = d3.format(',.1f')
            var stateObj = d[0].datum;
            // Comparing data inside object and return property name used before in html fo xAxis
            var varX = Object.keys(stateObj).filter(function(key) {
              return format(stateObj[key]) === format(d[0].x);
            });
            // Comparing data inside object and return property name used before in html fo yAxis
            var varY = Object.keys(stateObj).filter(function(key) {
              return format(stateObj[key]) === format(d[0].y);
            });
            console.log(d, stateObj);
            var html;
            html = '<span>' + stateObj.NOM_ENT + '</span><br>';
            html += '<span>(' + format(d[0].y) + ', ' + format(d[0].x) + ')</span>';

            return html;
          });

          d3.select('#scatter svg').call(scatterTip);

          national.each(function(d){
            scatterTip.show(scatterx, national.node());
          });

          if (vm.selectedOne !== null) {
            d3.select('#states-' + vm.selectedOne.d.CVE_ENT).attr('fill', function(d) {
              if (map._config.map.quantiles.colorsOnHover) { // OnHover colors
                return map._getQuantileColor(d[map._config.color], 'onHover');
              }
            });
          }

          if (vm.selectedTwo !== null) {
            d3.select('#states-' + vm.selectedTwo.d.CVE_ENT).attr('fill', function(d) {
              if (map._config.map.quantiles.colorsOnHover) { // OnHover colors
                return map._getQuantileColor(d[map._config.color], 'onHover');
              }
            })
          }

        }
      },
      tip: function(d) {
        return d.properties.state_name;
      }
    };

    vm.chart = dbox.chart(config)
      .bindTo('#map')
      .data({'csv': 'assets/data/coeficienteTAI.csv'})
    .layer(dbox.map)
      .id('CVE_ENT')
      .color(vm.topic)
    .end()
      .draw();
  }

  select(data) {
    // console.log('dboxMap.component - Selected by parent',data)
    const map = this.chart.layers[0];

    d3.select('#states-' + data.d.CVE_ENT).attr('fill', function(d) {
      if (map._config.map.quantiles.colorsOnHover) { // OnHover colors
        return map._getQuantileColor(d[map._config.color], 'onHover');
      }
    })
  }

  unselect(data) {
    const vm = this;
    // console.log('dboxMap.component - UnSelected by parent',data)
    const map = this.chart.layers[0]

    /**
     * If there is a selectedOne, the selectedOne is the same as the houver out,
     * and the trigger is not a user click or dropdown selection = Do noting
     */
    if (vm.selectedOne !== null && vm.selectedOne.d.CVE_ENT === data.d.CVE_ENT && data.by !== 'user') {
      return false;
    }

    /**
     * If there is a selectedOne, the selectedOne is the same as the houver out,
     * and the trigger is not a user click or dropdown selection = Do noting
     */
    if (vm.selectedTwo !== null && vm.selectedTwo.d.CVE_ENT === data.d.CVE_ENT && data.by !== 'user') {
      return false;
    }

    /**
     * If the user hovers out and it is not one of the selectedOne or selectedTwo = Restore the default color
     */
    d3.select('#states-' + data.d.CVE_ENT).attr('fill', function(d) {
      return map._getQuantileColor(d[map._config.color], 'default');
    })
  }

    /** selectedTopic: get variable selected from navbar in map
   * @returns {string} 
   * @since v2
  */
  selectedTopic(data){
    var actualClass = d3.select('.nav-extended .tabs-transparent .active').attr('class');
    var actual = actualClass.split(" ");
    var format = d3.format('.2f');

    switch(actual[0]){
      case 'coeficiente_TAI':
        return format(data[0].coeficiente_TAI);
      case 'corrupcion':
        return format(data[0].corrupcion);
      case 'impunidad':
        return format(data[0].impunidad);
      case 'opacidad':
        return format(data[0].opacidad);
    }
  }
}



// WEBPACK FOOTER //
// /home/azu/Proyectos/impunidad/impunidad-cero-tai/src/app/dboxMap/dboxMap.component.ts